/**
 * @file tableRoot.saga.js
 * @description
 *
 * @copyright veriome labs, llc.  - all rights reserved.
 * This file is subject to the terms and conditions defined in
 * file 'LICENSE.md', which is part of this source code package.
 *
 * @author don michael
 * @since Nov 06, 2025 20:46
 */
import { all, fork } from 'redux-saga/effects';

import tableEdit from './tableEdit.saga';
import tableUpdate from './tableUpdate.saga';
import tableView from './tableView.saga';

export default function* rootSaga() {
    yield all([
        fork(tableEdit),
        fork(tableUpdate),
        fork(tableView)
    ]);
}